import type { RefreshAttempt, StaleReason } from '../model/operations';
import { LABEL_KEYS, type Message } from './messages';

export type RecoveryBannerKind = 'outcomeUnknown' | 'refreshFailed';

export type RecoveryBannerViewModel = {
  kind: RecoveryBannerKind;
  title: Message;
  body: Message;
  actionLabel: Message;
  busy: boolean;
  testId: string;
};

export type RecoveryBannerInput = {
  staleReason: StaleReason | null;
  refreshAttempt: RefreshAttempt;
};

const RECOVERY_BANNER_TEST_ID = 'recovery-banner';

const OUTCOME_UNKNOWN_BANNER: Omit<RecoveryBannerViewModel, 'busy'> = {
  kind: 'outcomeUnknown',
  title: { key: LABEL_KEYS.recoveryOutcomeUnknownTitle },
  body: { key: LABEL_KEYS.recoveryOutcomeUnknownBody },
  actionLabel: { key: LABEL_KEYS.recoveryOutcomeUnknownAction },
  testId: RECOVERY_BANNER_TEST_ID,
};

const REFRESH_FAILED_BANNER: RecoveryBannerViewModel = {
  kind: 'refreshFailed',
  title: { key: LABEL_KEYS.recoveryRefreshFailedTitle },
  body: { key: LABEL_KEYS.recoveryRefreshFailedBody },
  actionLabel: { key: LABEL_KEYS.recoveryRefreshFailedAction },
  busy: false,
  testId: RECOVERY_BANNER_TEST_ID,
};

export function resolveRecoveryBanner({
  staleReason,
  refreshAttempt,
}: RecoveryBannerInput): RecoveryBannerViewModel | null {
  if (staleReason === null) {
    return null;
  }

  if (refreshAttempt.status === 'failed') {
    return REFRESH_FAILED_BANNER;
  }

  return {
    ...OUTCOME_UNKNOWN_BANNER,
    busy: refreshAttempt.status === 'inFlight',
  };
}
